// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.align-right {
  text-align: right;
}

.align-left {
  text-align: left;
}

.small-text {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./projects/eCash/src/app/manage-request/approval-route/approval-route.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,eAAA;AACJ","sourcesContent":["ul {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n.align-right {\n    text-align: right;\n}\n\n.align-left {\n    text-align: left;\n}\n\n.small-text {\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
